var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDateAscending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.036 27.75c-.213.48-.693.8-1.119.8h-3.835v6.73c0 .96-.8 1.705-1.705 1.705a1.683 1.683 0 0 1-1.704-1.704v-6.732h-3.889c-.532 0-1.012-.32-1.172-.799a1.308 1.308 0 0 1 .214-1.385l5.54-5.965c.532-.533 1.384-.533 1.864 0l5.54 5.965c.425.373.479.906.266 1.385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.571 4c.891 0 1.608.669 1.608 1.5V8h9.642V5.5c0-.831.717-1.5 1.608-1.5.89 0 1.607.669 1.607 1.5V8h2.678C32.078 8 34 9.794 34 12v6h-3.214v-2H7.214v16c0 .55.482 1 1.072 1H24v3H8.286C5.922 36 4 34.206 4 32V12c0-2.206 1.922-4 4.286-4h2.678V5.5c0-.831.717-1.5 1.607-1.5",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDateAscending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/date-ascending.b04513a49b62efcde5be2abe915539d6.svg";